// @flow

import type { State } from "@store/reducers";
import { getPagination } from "@selectors";
import type {
  OutstandingTask,
  SelectedTask,
  QuestionAnswers,
} from "@modules/reporting/reducer/tasks/types";
import type { RtwInterviewHistory } from "@modules/shared/reducer/employee-absences/types";
import type { PaginationExtendedType } from "@types";

export const getMyTasksRoot = (state: State) => ((state.reporting || {}).tasks || {}).myTasks || {};

export const getMyTasks = (state: State): OutstandingTask[] => getMyTasksRoot(state).list.content;

export const getSelectedTask = (state: State): ?SelectedTask => getMyTasksRoot(state).selectedTask;

export const isLoading = (state: State): boolean => state.reporting.tasks.requestsInProgress > 0;

export const getSelectedTaskRequestCount = (state: State): number =>
  state.reporting.tasks.requestsInProgress;

export const getSelectedTaskHistory = (state: State): ?RtwInterviewHistory =>
  getMyTasksRoot(state).selectedTaskHistory;

export const getAbsenceTaskSchema = (state: State): ?Object =>
  state.reporting.tasks.schemas.absenceTask;

export const getSelectedTaskQuestionAnswers = (state: State): ?QuestionAnswers =>
  (getMyTasksRoot(state).selectedTask || {}).questionAnswers;

export const getMyTasksTotalCount = (state: State): number => getMyTasksRoot(state).totalTasksCount;

export const getMyTasksOverdueCount = (state: State): number => getMyTasksRoot(state).overdueCount;

export const getMyReferralDecisionTaskCount = (state: State): number => {
  return (((state.reporting || {}).tasks || {}).myTasks || {}).referralDecisionTaskCount;
};

export const getMyTasksRtwInterviewTasksCount = (state: State): number =>
  getMyTasksRoot(state).rtwInterviewTasksCount;

export const getMyTasksReferralDecisionTaskCount = (state: State): number =>
  getMyTasksRoot(state).referralDecisionTaskCount;

export const getMyTasksAbsenceMonitoringReviewTaskCount = (state: State): number =>
  getMyTasksRoot(state).absenceMonitoringReviewTaskCount;

export const isLateSubmissionModalVisible: (stet: State) => boolean = (state: State) =>
  state.reporting.tasks.modals.showLateSubmissionModal;

export const selectMyTasksPagination = (state: State): PaginationExtendedType =>
  getPagination(state.reporting.tasks.myTasks.list);

export const selectMyTasksSearch = (state: State): string => {
  return state.reporting.tasks.search.employee;
};

export const selectMyTasksType = (state: State): string | null => {
  return (((state.reporting || {}).tasks || {}).search || {}).type;
};
